import _ from 'lodash';
import utilities from '@/services/utilities/utilities';

export default class PresetHoleCards {
  constructor() {
    this.holeCardOne = null;
    this.holeCardTwo = null;
  };

  get numSet() {
    let numPreset = 0;

    if (this.holeCardOne) {
      numPreset++;
    }

    if (this.holeCardTwo) {
      numPreset++;
    }

    return numPreset;
  };
  get array() {
    return utilities.general.getHoleCardsArrayFromObj(this);
  };
  get bothSet() {
    return this.holeCardOne && this.holeCardTwo;
  }
};



// WEBPACK FOOTER //
// ./src/services/PresetHoleCards.js